<template>
    <div v-if="firstRendered">
        <div class="filter-condition box-shadow-small border-radius">
            <p class="mt-10 mb-20">
                <router-link to="/written">笔试</router-link>
                >
                <span>笔试安排列表</span>
            </p>
            <div class="search-box">
                <el-button class="search-hd" type="primary" icon="el-icon-search" @click="searchKeyword(keyword)"></el-button>
                <div class="search-bd">
                    <search-bar v-model="keyword" @enter-key="searchKeyword" @select="searchKeyword" :ajaxSearch="false"
                                placeholder="请输入考试标题进行搜索"></search-bar>
                </div>
            </div>
            <div class="filter-panel">
                <dl>
                    <dt>笔试安排时间：</dt>
                    <dd>
                        <el-date-picker type="date" placeholder="请选择时间"
                                        :editable="false"
                                        format="yyyy-MM-dd"
                                        @change="changeArrangeTime"
                                        v-model="timeForm.arrangeTime"></el-date-picker>
                    </dd>
                </dl>
                <dl>
                    <dt>笔试开始时间：</dt>
                    <dd>
                        <el-date-picker type="date" placeholder="请选择时间"
                                        :editable="false"
                                        format="yyyy-MM-dd"
                                        @change="changeStartTime"
                                        v-model="timeForm.startTime"></el-date-picker>
                    </dd>
                </dl>
            </div>
        </div>
        <div class="filter-result background-white box-shadow-small border-radius">
            <div v-loading="partialLoading">
                <empty-tip :show="!lists.length"></empty-tip>
                <div class="table-list mt-20">
                    <el-table v-if="lists.length"
                              :data="lists">
                        <el-table-column
                                label="考试标题"
                                :show-overflow-tooltip="true"
                                align="center"
                                prop="title"
                                min-width="120">
                        </el-table-column>
                        <el-table-column
                                prop="examRules"
                                label="考生须知"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="100">
                        </el-table-column>
                        <el-table-column
                                label="考试时间"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="100">
                            <template slot-scope="scope">
                                <p v-for="(item, index) in scope.row.examTimes" :key="index">{{item.startTime}}-{{item.endTime.slice(10)}}</p>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="笔试题试卷"
                                :show-overflow-tooltip="true"
                                align="center"
                                :formatter="tableColumnFormatter"
                                min-width="60">
                            <template slot-scope="scope">
                                <p v-for="(item, index) in scope.row.paperList" :key="index">{{item.name}}</p>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="操作"
                                align="center"
                                class-name="no-wrap"
                                min-width="100">
                            <template slot-scope="scope">
                                <router-link :to="`/written/exam/detail/${scope.row.id}`">
                                    <el-button type="text">查看详情</el-button>
                                </router-link>
                                <router-link :to="`/written/recommend/${scope.row.id}`" class="ml-10" v-if="false">
                                    <el-button type="text">修改</el-button>
                                </router-link>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <el-pagination
                        v-if="lists.length"
                        class="text-center mt-20 mb-20"
                        @size-change="pageSizeChange"
                        @current-change="pageIndexChange"
                        :current-page="pagination.pageIndex"
                        :page-size="pagination.pageSize"
                        :page-sizes="[20, 50, 100, 200]"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="pagination.recordCounts">
                </el-pagination>
            </div>
        </div>
    </div>
</template>
<script type="text/javascript">
    import QueryListExtend from 'components/queryListExtend'
    import selectMapMixin from 'mixins/selectMapMixin'
    import operationMixin from '../operation/operationMixin'
    import queryListMixin from '../operation/queryListMixin'
    import StatusIcon from 'components/statusIcon'

    export default {
        components: {StatusIcon},
        'extends': QueryListExtend,
        'mixins': [selectMapMixin, operationMixin, queryListMixin],
        data () {
            return {
                fetchUrl: '/exam/list.api',
                timeForm: {
                    arrangeTime: this.$route.query.arrangeTime ? new Date(this.$route.query.arrangeTime) : '',
                    startTime: this.$route.query.startTime ? new Date(this.$route.query.startTime) : ''
                },
                searchData: {
                    searchWord: null,
                    arrangeTime: '',
                    startTime: ''
                }
            }
        },
        methods: {
            multiProcess (routeName) {
                if (!this.checkDataValid(this.idStr)) {
                    return false
                }
                this.$router.push({name: routeName, params: {ids: this.idStr}})
            },
            changeArrangeTime (value) {
                console.log(123, value)
                this.searchData.arrangeTime = value
            },
            changeStartTime (value) {
                console.log(123, value)
                this.searchData.startTime = value
            },
            tableColumnFormatter (row, column, value) {
                return value || '-'
            }
        }
    }
</script>
<style type="text/css" lang="scss">
    @import "~variable";

    .dark-theme {
        background    : #1f2d3d;
        color         : #fff;
        border-radius : $border-radius;
        &[x-placement^="top"] .popper__arrow::after {
            border-top-color : #1f2d3d;
        }
    }

    .popper-line {
        .el-row {
            word-break : break-all;
            padding    : 3px 0;
            &:not(:first-child) {
                border-top : 1px solid #415062;
                margin-top : 1px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// writtenArrangementList.vue?a2f86ffe